import { Button } from 'antd'
import React from 'react'

function LinkButton({children}) {
  return (
    <Button type="link" className='auf-button'>{children}</Button>
  )
}

export default LinkButton